export const RITA_MANUAL_BASE_URL = 'https://rita-manual.logcluster.org';

/**
 * RITA manual node ids. Keys are semantic page names; entries
 * exist for every documented screen, including ones not yet built in this
 * frontend, so new pages only need to reference their node here.
 */
export const MANUAL_NODES = {
  // General & Dashboard
  DASHBOARD: 371,
  GLOBAL_HELP: 377,
  STORAGE_OVERVIEW: 372,
  TRANSPORT_OVERVIEW: 373,
  MAPPING: 374,
  SERVICE_USERS: 375,

  // Request management
  CONSIGNMENTS_LIST: 321,
  SERVICE_REQUESTS_LIST: 318,
  ONLINE_SRFS_LIST: 307,
  ONLINE_SRF_CREATION: 458,

  // Receiving
  RECEIVE: 350,
  RECEIVE_HISTORY: 351,
  RECEIVE_LOSSES: 352,

  // Dispatching & releasing
  DISPATCH_PLANNING_STOCK_ON_HAND: 359,
  DISPATCH_PLANNING_AWAITING_COLLECTION: 360,
  DISPATCH_PLANNING_PLANNED_JOURNEYS: 361,
  DISPATCH_PENDING_HISTORY: 356,
  DISPATCH_IN_PROGRESS_HISTORY: 355,
  DISPATCH_HISTORY: 357,
  RELEASE_ORDERS: 365,
  RELEASE_HISTORY: 367,
  RELEASE_ORDER_REQUEST: 464,

  // Warehouse management
  WAREHOUSE_MANAGEMENT: 358,
  INVENTORY_COUNT: 368,
  WAREHOUSE_LOSS_HISTORY: 366,

  // Reports
  REPORT_TRANSPORT_PLANNING: 369,
  REPORT_STORAGE_PLANNING: 381,
  REPORT_SERVICE_OVERVIEW: 370,
  REPORT_CONSIGNMENT_OVERVIEW: 384,
  REPORT_RELEASE_OVERVIEW: 383,
  REPORT_LOSS_OVERVIEW: 397
} as const;

/** Manual pages addressed by path instead of a node id. */
export const MANUAL_PATHS = {
  CARGO_DIMENSION_CALCULATOR: 'cargo-dimension-calculator'
} as const;

/** A manual destination: a node id (→ `node/NNN`) or a direct path segment. */
export type ManualTarget = number | string;

export function buildManualUrl(language: string, target: ManualTarget): string {
  const lang = (language || 'en').split('-')[0];
  const path = typeof target === 'number' ? `node/${target}` : target;

  return `${RITA_MANUAL_BASE_URL}/${lang}/${path}`;
}
